module.exports = __webpack_public_path__ + "static/media/profile-coupon-red.bcec48c6.svg";